import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {ListGroupRequest, GroupResponse, Paginated} from './types'

export interface ListGroup<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const listGroup: ListGroup<
  ListGroupRequest,
  Paginated<GroupResponse>
> = (http, params) => {
  const {PageNumber, PageSize, OrderBy, OrderAscending, ClientID} = params

  const path = '/v1/eztexting/group'

  const queryParams = []
  if (PageNumber !== undefined) {
    queryParams.push(`pagenumber=${PageNumber}`)
  }
  if (PageSize !== undefined) {
    queryParams.push(`pagesize=${PageSize}`)
  }
  if (OrderBy !== undefined) {
    queryParams.push(`orderby=${OrderBy}`)
  }
  if (OrderAscending !== undefined) {
    queryParams.push(`orderascending=${OrderAscending}`)
  }
  if (ClientID !== undefined) {
    queryParams.push(`clientid=${ClientID}`)
  }
  const query = `?${queryParams.join('&')}`

  return http.request<Paginated<GroupResponse>>({
    method: 'GET',
    url: `${path}${query}`,
  })
}
